import IFaturaPrevista from "../interfaces/IFaturaPrevista";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class FaturaPrevistaService {
    async createByFaturaUsina(id: any) {
        return await api.post<IFaturaPrevista>(`${resources.faturaPrevista}/CreateByFaturaUsina/${id}`);
    }

    async Postergar(id: any) {
        return await api.post<IFaturaPrevista>(`${resources.faturaPrevista}/Postergar/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.faturaPrevista}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async charge(data: any) {
        return await api.post<IFaturaPrevista>(`${resources.faturaPrevista}/Charge/${ToQueryString(data)}`);
    }

    async reopen(id: any) {
        return await api.post(`${resources.faturaPrevista}/Reopen/${id}`);
    }
}

export default new FaturaPrevistaService();
